<template>
    <table class="table efsa">
    <colgroup>
        <col width="20%">
        <col width="10%">
        <col width="15%">
        <col width="15%">
        <col width="35%">
    </colgroup>
    <thead>
    <tr>
        <th>
            <div>Reference</div>
            <div>Trial or study name (geography)</div>
        </th>
        <th>
            <div>Study type</div>
            <div>Duration</div>
        </th>
        <th>
            <div>Participants in the study</div>
            <div>Year of sampling for measurement effect</div>
        </th>
        <th>
            <div>Sample analysed for BPA exposure</div>
            <div>BPA type measured (free or conjugated)</div>
        </th>
        <th>
            <div>Parameters measured and Measures of effect</div>
            <div>General outcome of the study</div>
        </th>
    </tr>
    </thead>

        <transition-group name="record-list" tag="tbody" class="record-list">
            <tr v-for="record of active_records" :key="record.refid" class="record">
                <td>
                    <div class="refid">#{{ record.refid }}</div>
                    <div><strong>{{ record.author }} <span
                            v-if="record.year">({{ record.year }})</span></strong></div>
                    <div>{{ record.title }}</div>
                </td>

                <td>
                    <data-list :data="record.data.bpa_st_ch_h_st_typ_sop" :highlight="active_study_type"/>
                    <br>
                    <data-list :data="record.data.bpa_st_ch_h_yr"/>
                </td>
                <td>
                    <data-list :data="record.data.bpa_st_ch_h_tot_n"/>
                    <br>
                    <data-list :data="record.data.bpa_st_ch_h_date_effect"/>
                </td>
                <td>
                    <data-list :data="record.data.bpa_st_ch_h_anal_bpa_sampl"/>
                    <br>
                    <div v-for="(tc_rec, index) of record.data.type_conj" :key="index">
                        {{ tc_rec.join(" / ") }}
                    </div>
                </td>
                <td>
                    <div v-for="(endp, index) of record.data.bpa_st_res_h_endp_" :key="index" :class="{'yellow': active_endpoint === endp.join(' / ')}">
                        {{ endp.join(" / ") }}
                    </div>
                    <br>
                    <data-list :data="record.data.bpa_st_ch_h_outc_overall"/>
                </td>
            </tr>
        </transition-group>

    </table>
</template>
<script>
  import DataList from './DataList'

  export default {
    name: 'AnimalTable',
    components: {DataList},
    props: {
      active_records: {},
      active_endpoint: null,
      active_study_type: null
    }
  }
</script>
<style lang="scss">
</style>
